import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Position } from '../../models/position';
import { PositionService } from '../../services/position.service';
import { CoreSaveService, ConfigService, UtilsService, MessageService, ICommonMessage, FieldType } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { DatePipe } from '@angular/common';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export'; 

@Component({
  selector: 'app-position',
  templateUrl: './position.component.html',
  styleUrls: ['./position.component.css']
})
export class PositionComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view')view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerPosition: PageHeader;
  entity: Position = new Position();
  editingEntity: Position = new Position();
  selectedPosition: Position = new Position();
  positions: any;
  positionColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = '';
  pipe = new DatePipe('en-US');
  emailcheck: boolean = true;
  defaultRowsCount: number;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  saveDisabled: boolean = false; 
  selectedPositionLevel: any;
  opened:boolean=false;
  details:any;

  constructor(
    private _positionService: PositionService,
    private configService: ConfigService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService, 
  ) {
    this.headerPosition = this.initPageHeader();
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.positions = [];
    this.getAllPositions();
  }
  ngAfterViewInit():void{
    this.positionColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 60 },
      { field: "PositionName", title: 'Position', filter: true, sortable: true, width: 200 },
      { field: "Code", title: 'Code', filter: true, sortable: true, width: 150 }, 
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 150 },
      {field:"",filter:true,sortable:true,template: this.view, width: 80  }
    ];
  }
  
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._positionService.getAllPosition('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Position>) => {
      this.positions = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  } 
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._positionService.getAllPosition(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((positions: Array<Position>) => {
        this.positions = {
          data: positions,
          total: positions[0] ? positions[0].TotalCount : 0
        }
      });
    }
  }
  getAllPositions() {
    this._positionService.getAllPosition('', Number(this.defaultPageSize), 1, 0, 0).subscribe((positions: Array<Position>) => {
      this.positions = {
        data: positions,
        total: positions[0].TotalCount
      }
    });
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._positionService.deletePosition(this.selectedPosition.Position_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearPosition();
            this.getAllPositions();
          },
          )
        }
      }
    });
  }
  goToBackTab(): void {
    this.listView=true;
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }
  }
  initPageHeader(): PageHeader {
    let headerPosition = new PageHeader();
    headerPosition.PageCaption = "Position";
    headerPosition.IconClass = "bi bi-building";
    return headerPosition;
  }

  deletePosition(event: any) {
    if (event.seletedRows[0]) {
      this.selectedPosition.Position_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Position",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addPosition(event: any) {
    this.listView = false;
    this.clearPosition(); 
    this.formCaption = "Add Position";
  }

  editPosition(event: any): void {
    if (event.seletedRows[0]) {
      this._positionService.viewPosition(event.seletedRows[0]).subscribe((positions: Array<Position>) => {
        let editPosition = positions[0] ? positions[0] : new Position();
        if (editPosition) {
          this.editingEntity = editPosition;
          this.entity = { ...this.editingEntity };
          this.listView = false; 
          this.formCaption = "Edit Position";
          this.entity.EntityMetaData = [
            { FieldName: 'PositionName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Position Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
          ];
        }
      });
    }
  }

  save(event: any): void {
    if(parseInt(this.entity.Code)==0){
      this.notification.showWarning("Zero not allowed")
      return
    }
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._positionService.checkDuplication(this.entity.PositionName, this.entity.Position_Id).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Position already exists');
          this.saveDisabled = false;
        }
        else {
          this._positionService.savePosition(this.entity).subscribe(() => {
            if (this.entity.Position_Id == "00000000-0000-0000-0000-000000000000") {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearPosition();
            this.getAllPositions();
          })
        }
      });
    }

    else {
      this.saveDisabled = false;
    }
  }
  gotoBack(): void {
    this.listView = true;
    this.clearPosition();
  }
  refreshPosition(event: any): void {
    this.positions=[];
    this.getAllPositions();
  }
  clearPosition(): void {
    this.entity = new Position();
    this.saveDisabled = false;
  }
  onExcelExport() {
    this.excelexport.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
    this.entity.Position_Id = dataItem.Position_Id;
    this.details = [];
    this._positionService.viewPosition(this.entity.Position_Id).subscribe((positions: Array<Position>) => {
      this.opened = true;
      this.details = positions[0];
    })}
}
